// extracted by mini-css-extract-plugin
module.exports = {"root":"_26b799589ad331b2e2bd574fe080fe39"};